<script setup>
import SimpleModal from '@/components/modal/SimpleModal.vue';
import FormInput from '@/components/form/FormInput.vue';
import FordButton from '@/components/FordButton.vue';
import { ref } from 'vue';

const emit = defineEmits(['join', 'register', 'try-again', 'close']);

defineProps({
  id: String,
  statuses: Object,
  status: String,
});

const emailAddress = ref('');

const join = () => {
  emit('join', emailAddress.value);
};

const tryAgain = () => {
  emailAddress.value = '';
  emit('try-again');
};
</script>
<template>
  <simple-modal @close="() => emit('close')">
    <template v-slot:body>
      <template
        v-if="status === statuses.default || status === statuses.loading"
      >
        <form @submit.prevent="join">
          <form-input
            type="email"
            label="Please enter the email you registered with"
            placeholder="Email Address"
            v-model="emailAddress"
          />
          <ford-button @method="join">
            <img
              v-if="status === statuses.loading"
              :src="require('@/assets/img/spinner.svg')"
              alt="spinner"
            />
            <span v-else>Join</span>
          </ford-button>
        </form>
      </template>
      <template v-if="status === statuses.failed">
        <p class="text-ford-gray-darker mb-8">
          Please make sure to use the email address you registered with.
        </p>
        <div
          class="
            flex flex-col
            items-center
            gap-y-4
            tablet-sm:flex-row tablet-sm:justify-between
          "
        >
          <ford-button
            transparent
            minWidth="189"
            @method="() => emit('register')"
            >Register</ford-button
          >
          <ford-button minWidth="189" @method="tryAgain">Try again</ford-button>
        </div>
      </template>
    </template>
  </simple-modal>
</template>
